import { MapPin } from 'lucide-react'

import type { Clinic } from '@snootsvet/shared/portal'

/**
 * Fine-print link to a clinic's Google Maps listing. Prefers the
 * clinic's Place ID (canonical pin) and falls back to the street
 * address query when no Place ID is on file.
 */
export function ClinicMapsLink({
  clinic,
  className,
}: {
  clinic: Pick<Clinic, 'id' | 'name' | 'address' | 'googlePlaceId'>
  className?: string
}) {
  const href = clinic.googlePlaceId
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clinic.name)}&query_place_id=${clinic.googlePlaceId}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clinic.address)}`

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      className={`inline-flex items-start gap-1.5 text-fine-print text-muted-foreground underline underline-offset-2 transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className ?? ''}`}
    >
      <MapPin className="mt-0.5 size-3.5 shrink-0" aria-hidden />
      {clinic.address}
    </a>
  )
}
